import React, { useCallback, useEffect } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { compose } from "redux";
import { injectIntl } from "react-intl";
import { getFaqFeedback, setFaqFeedback } from "../../actions";
import injectReducer from "../../../../utils/reducers/injectReducer";
import injectSaga from "../../../../utils/saga/injectSaga";
import saga from "../../saga";
import reducer from "../../reducer";
import FeedbackAlert from "../../component/FeedbackAlert";

const CourseFaqsDetailPage = (props) => {
  const { id } = props;

  const dispatch = useDispatch();
  const getLastVideoLessonsAPI = useCallback((idNum) => dispatch(getFaqFeedback(idNum)), [
    dispatch,
  ]);
  const setFaqFeedbackAPI = useCallback(
    (idNum, isGood) => dispatch(setFaqFeedback(idNum, isGood)),
    [dispatch]
  );
  const {
    faq: { isGood, sended },
    loading,
  } = useSelector((state) => state["course[faqs]"]);

  useEffect(() => {
    getLastVideoLessonsAPI(id);
  }, []);

  return (
    <FeedbackAlert
      feedbackAtion={(isGoodValue) => {
        setFaqFeedbackAPI(id, isGoodValue);
      }}
      isGood={isGood}
      sended={sended}
      loading={loading}
    />
  );
};

const withReducer = injectReducer({ key: "course[faqs]", reducer });
const withSaga = injectSaga({ key: "course[faqs]", saga });

export default compose(withReducer, withSaga)(injectIntl(CourseFaqsDetailPage));

CourseFaqsDetailPage.propTypes = {
  id: PropTypes.number.isRequired,
};
